var _excluded = ["children", "className", "type", "visible", "icon"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { successIcon, errorIcon, infoIcon, warningIcon } from '@lululemon/ecom-pattern-library-icons';
import cs from 'classnames';
import Icon from '../icons';
require("./notification.css");
var styles = {
  "notificationBlock": "notificationBlock-1RRMY",
  "iconBlock": "iconBlock-1wZMf",
  "successNotification": "successNotification-1HovB",
  "errorNotification": "errorNotification-1QZaf",
  "warningNotification": "warningNotification-1jaxD",
  "infoNotification": "infoNotification-1saC6",
  "messageNotification": "messageNotification-3i9f9"
};
var Notification = _ref => {
  var {
      children,
      className,
      type,
      visible,
      icon
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var roleValue = type === 'error' || type === 'warning' ? 'alert' : 'status';
  var iconContent = {
    error: errorIcon,
    info: infoIcon,
    success: successIcon,
    warning: warningIcon,
    message: infoIcon
  };
  var iconContentValue = !icon ? iconContent[type] : icon;
  return /*#__PURE__*/React.createElement("div", {
    role: roleValue
  }, visible ? /*#__PURE__*/React.createElement("div", _extends({
    className: cs(styles.notificationBlock, className, {
      [styles.errorNotification]: type === 'error',
      [styles.infoNotification]: type === 'info',
      [styles.successNotification]: type === 'success',
      [styles.warningNotification]: type === 'warning',
      [styles.messageNotification]: type === 'message'
    })
  }, otherProps), /*#__PURE__*/React.createElement(Icon, {
    content: iconContentValue,
    className: styles.iconBlock
  }), /*#__PURE__*/React.createElement("div", null, children)) : null);
};
Notification.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning', 'message']),
  /** Prop to control whether or not the content within the Notification is rendered */
  visible: PropTypes.bool,
  icon: PropTypes.node
};
Notification.defaultProps = {
  className: null,
  type: 'info',
  visible: false,
  icon: null
};
export default Notification;